//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";



//--------------- FUNÇÃO ASSÍNCRONA UPDATE USER SERVICE ---------------//
// Responsável por requisitar à API a Atualização do Usuário
export default async function updateUserService(userIdEdited, password) {
    if (!password) {
        toast.warn("Preencha a nova senha");
        return false;
    }
    try {
        await api.put(`/usuarios/${userIdEdited}`, { senha: password });
        toast.success("Senha atualizada com sucesso");
        return true;
    } catch (err) {
        toast.error("Erro ao atualizar senha");
        return false;
    }
}